module.exports = __webpack_public_path__ + "img/大咖说.baa4598c.png";